/**
 */
import type { RootState } from '/business/shared/state/store';
import { createSelector } from 'reselect';

import getAuthRules from './getApplicationAuthRulesSelector';

const getPermissionName = (_state: RootState, permissionName: string) => permissionName;

export default createSelector([getAuthRules, getPermissionName], (rules, permissionName) => {
  const matched = rules?.filter((rule) => {
    return rule === permissionName;
  });
  return matched.length > 0;
});
